<section class='container'>
    <app-header [gameScore]='this.gameScore'></app-header>
    <app-body
    (gameScoreEmitter)='getGameScore($event)'
    (rulesModalEventEmitter)='rulesModal(true)'></app-body>
</section>
<app-rules-modal 
    *ngIf='showRulesModal'
    (rulesModalEventEmitter)='rulesModal(false)'
></app-rules-modal>